import { useEffect, useRef, useState } from 'react';
import call from '~/assets/icons/call.svg';
import { rage, useObservable } from '~/rage';
import { PhoneCallStatus, formatTime } from '~/shared';
import {
	StyledButton,
	StyledContactName,
	StyledContainer,
	StyledNumber,
	StyledTime,
} from './AppPhoneCall.styled';

const AppPhoneCall = () => {
	const phoneState = useObservable(rage.phoneCalls.getCallState());
	const [callDuration, setCallDuration] = useState(0);
	const intervalRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		if (
			phoneState?.status === PhoneCallStatus.CONNECTED &&
			phoneState.startTime
		) {
			intervalRef.current = setInterval(() => {
				const duration = Math.floor(
					(Date.now() - phoneState.startTime!) / 1000,
				);
				setCallDuration(duration);
			}, 1000);
		} else if (phoneState?.status === PhoneCallStatus.DIALING) {
			setCallDuration(0);
		} else {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}
			setCallDuration(0);
		}

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
	}, [phoneState?.status, phoneState?.startTime]);

	const getDisplayTime = (): string => {
		if (phoneState?.status === PhoneCallStatus.DIALING) {
			return '00:00';
		}
		return formatTime(callDuration * 1000, '{mm}:{ss}');
	};

	return (
		<StyledContainer>
			<StyledContactName>{phoneState?.contactName}</StyledContactName>
			<StyledNumber>{phoneState?.contactNumber}</StyledNumber>
			<StyledTime>{getDisplayTime()}</StyledTime>
			<StyledButton onClick={() => rage.phoneCalls.endCall()}>
				<img src={call} />
			</StyledButton>
		</StyledContainer>
	);
};

export { AppPhoneCall };
